var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uses__container"},[_c('uses-content'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }